import React, { useState, useContext, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import CloudOffIcon from '@mui/icons-material/CloudOff';

import { ThemeContext } from 'components/common/App';

import videoApi from 'lib/video-api';


export default function YouTubePreservePage() {
  const theme = useContext(ThemeContext)
  const navigate = useNavigate()

  const [videoAPIHealth, setVideoAPIHealth] = useState(false)
  const [youtubeUrl, setYoutubeUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    theme.changeTheme("light-bg")
    window.scrollTo(0, 0)

    videoApi.get("/v1/health").then(response => {
      if (response.data.status === "ok") {
        setVideoAPIHealth(true)
      } else {
        setVideoAPIHealth(false)
      }
    }).catch(error => {
      console.error(error)
      setVideoAPIHealth(false)
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    videoApi.post('/v1/video/youtube', { url: youtubeUrl }, {
      headers: {
        'Content-Type': 'application/json',
        'X-Token': localStorage.getItem('accessKey'),
      },
    })
      .then(response => {
        setLoading(false)
        navigate(`/videos/details/${response.data.job_id}`)
      })
      .catch(error => {
        setLoading(false)
        const message = error.response?.data?.detail || error.response?.data?.error || 'Failed to download video'
        setError(message)
        console.error('Error downloading YouTube video:', error)
      })
  }

  return (
    <>
      <Helmet>
        <title>YouTube Download</title>
      </Helmet>
      <Container fixed>
        <form onSubmit={handleSubmit} method="post">
          <Box sx={{ flexGrow: 1, marginTop: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack direction={'row'} spacing={2}>
                  <Typography variant="h3">
                    YouTube Download
                  </Typography>
                  <Tooltip title="Connection Status for Video Library Manager">
                    {videoAPIHealth ?
                      <CloudQueueIcon fontSize='large' color="success" />
                      :
                      <CloudOffIcon fontSize='large' color="error" />
                    }
                  </Tooltip>
                </Stack>
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label="YouTube URL"
                  placeholder="https://www.youtube.com/watch?v=..."
                  value={youtubeUrl}
                  onChange={(e) => { setYoutubeUrl(e.target.value); setError(null) }}
                  disabled={loading || !videoAPIHealth}
                  error={!!error}
                  helperText={error}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  disabled={!youtubeUrl.trim() || loading || !videoAPIHealth}
                  variant="contained"
                >
                  {loading ? <CircularProgress size={24} /> : 'Download'}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </form>
      </Container>
    </>
  )
}
